import { ApolloError } from 'apollo-client'
import { ErrorMessage, Field, Form } from 'formik'
import { withFormik } from 'formik'
import * as React from 'react'
import { MutationFn } from 'react-apollo'
import { RouteComponentProps, withRouter } from 'react-router'
import styled from 'styled-components'
import * as Yup from 'yup'
import { Alert } from '../../atoms/Alert'
import { Button } from '../../atoms/Button'
import { FieldError } from '../../atoms/FieldError'
import { RadioButton } from '../../atoms/RadioButton'
import { CreatePainRatingMutation, CreatePainRatingMutationVariables } from '../../schema/schemaTypes'
import facesPainScale from './faces-pain-scale.png'

export interface IFormValues {
  painRating: string | null
}

export interface IViewProps extends RouteComponentProps<{ token: string }> {
  createPainRating: MutationFn<CreatePainRatingMutation, CreatePainRatingMutationVariables>
  data?: CreatePainRatingMutation
  error?: ApolloError
}

const PainRatingViewInner = ({ data, error }: IViewProps) => {
  if (data) {
    return (
      <Alert type="success" style={{ textAlign: 'center' }}>Thank you for submitting your child's pain rating!</Alert>
    )
  }

  return (
    <Form>
      <Img src={facesPainScale} />

      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i =>
        <Field
          key={i} id={'radio-' + i} name="painRating" value={i} label={'' + i}
          style={{ marginRight: 20, marginBottom: 20 }} component={RadioButton}
        />,
      )}
      <ErrorMessage name="painRating" component={FieldError} />

      {error && error.message === 'GraphQL error: Need to supply valid token to create pain rating' &&
        <Alert style={{ textAlign: 'center' }}>
          The link you used is not valid, please open the link in the email again or contact us</Alert>}

      <div style={{ marginTop: 20 }}><Button type="submit">SEND</Button></div>
    </Form>
  )
}

const validationSchema = Yup.object().shape({
  painRating: Yup.number().min(0).max(10).required('Required'),
})

export const PainRatingView = withRouter(withFormik<IViewProps, IFormValues>({
  handleSubmit: async (values, { props }) => {
    await props.createPainRating({
      variables: {
        painRating: parseInt(values.painRating!, 10), token: props.match.params.token,
      },
    })
  },
  mapPropsToValues: () => ({ painRating: null }),
  validationSchema,
})(PainRatingViewInner))


const Img = styled.img`
  margin: 16px 0 30px;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/organisms/PainRating/PainRatingView.tsx